module.exports = __webpack_public_path__ + "static/media/bh.0010a3cc.svg";